"use client";
import { Box } from "../../../core/Box/Box.mjs";
import Loader_module_default from "../Loader.module.mjs";
import cx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Loader/loaders/Bars.tsx
const Bars = ({ className, ...others }) => /* @__PURE__ */ jsxs(Box, {
	component: "span",
	className: cx(Loader_module_default.barsLoader, className),
	...others,
	children: [
		/* @__PURE__ */ jsx("span", { className: Loader_module_default.bar }),
		/* @__PURE__ */ jsx("span", { className: Loader_module_default.bar }),
		/* @__PURE__ */ jsx("span", { className: Loader_module_default.bar })
	]
});
Bars.displayName = "@mantine/core/Bars";
//#endregion
export { Bars };

//# sourceMappingURL=Bars.mjs.map